import React, { Component } from "react";
import styles from "./controlDrivers.module.scss";
import { withDrivers } from "../../../shared/containers/containerDrivers";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { TextField, Checkbox } from "@mui/material";
import InputDate from "../../../shared/items/contols/inputDate";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import { states } from "../../../reducers/queriesStates";

const driverLicenseCategory = {
  1: "A",
  2: "A1",
  4: "B",
  8: "B1",
  16: "C",
  32: "C1",
  64: "D",
  128: "D1",
  256: "BE",
  512: "CE",
  1024: "C1E",
  2048: "DE",
  4096: "D1E",
  8192: "AM",
  16384: "Tm",
  32768: "Tb",
};

class ControlDriverTool extends Component {
  constructor(props) {
    super(props);

    this.state = { isChange: false, selectedDriver: null };
  }

  componentDidMount() {
    const { selectedDriver } = this.props;

    this.setState({ selectedDriver });
  }

  componentDidUpdate(prevProps) {
    const { selectedDriver, driverCreateDataState, driverUpdateDataState } = this.props;

    if (
      (driverCreateDataState === states.READY && prevProps.driverCreateDataState === states.REQUEST) ||
      (driverUpdateDataState === states.READY && prevProps.driverUpdateDataState === states.REQUEST)
    ) {
      this.setState({ selectedDriver, isChange: false });
    }
  }

  onHandleChangeStore(title, value) {
    const { selectedDriver } = this.state;

    if (selectedDriver[title] !== value) {
      if (value instanceof Date) {
        if (selectedDriver[title].getTime() !== value.getTime()) {
          selectedDriver[title] = value;

          this.setState({ selectedDriver, isChange: true });
        }
      } else {
        selectedDriver[title] = value;

        this.setState({ selectedDriver, isChange: true });
      }
    }
  }

  onHandleChangeCheckBox(title, e) {
    const { selectedDriver } = this.state;
    if (e.target.checked) selectedDriver.categories[title] = driverLicenseCategory[title];
    else delete selectedDriver.categories[title];

    this.setState({ selectedDriver, isChange: true });
  }

  buttonDisabled() {
    const { selectedDriver } = this.state;

    const isNullOrEmpty = (value) => {
      return value === null || value === "";
    };

    if (
      isNullOrEmpty(selectedDriver.firstName) ||
      isNullOrEmpty(selectedDriver.lastName) ||
      isNullOrEmpty(selectedDriver.middleName) ||
      isNullOrEmpty(selectedDriver.licenseNumber) ||
      isNullOrEmpty(selectedDriver.licenseWhoGrant) ||
      Object.keys(selectedDriver.categories).length === 0
    ) {
      return true;
    }

    return false;
  }

  onHandleClicklButton() {
    const { selectedDriver } = this.state;
    const { onCreateDriver, onUpdateDriver } = this.props;

    if (selectedDriver.id === null) onCreateDriver(selectedDriver);
    else onUpdateDriver(selectedDriver);
  }

  render() {
    const { onSelectDriver } = this.props;
    const { selectedDriver, isChange } = this.state;
    if (selectedDriver === null) return;

    return (
      <div className={null}>
        <div
          className={styles.closeButton}
          onClick={() => {
            onSelectDriver(null);
          }}
        >
          <TooltipWrapper title={"Закрыть"} position="left">
            <HighlightOffIcon style={{ color: "red" }} />
          </TooltipWrapper>
        </div>

        <div className={styles.fieldContainer}>
          <TextField
            id="outlined-basic"
            label="Фамилия *"
            variant="outlined"
            size="small"
            fullWidth={true}
            value={selectedDriver.lastName}
            onChange={(e) => {
              this.onHandleChangeStore("lastName", e.target.value);
            }}
          />
        </div>

        <div className={styles.fieldContainer}>
          <TextField
            id="outlined-basic"
            label="Имя *"
            variant="outlined"
            size="small"
            fullWidth={true}
            value={selectedDriver.firstName}
            onChange={(e) => {
              this.onHandleChangeStore("firstName", e.target.value);
            }}
          />
        </div>

        <div className={styles.fieldContainer}>
          <TextField
            id="outlined-basic"
            label="Отчество"
            variant="outlined"
            size="small"
            fullWidth={true}
            value={selectedDriver.middleName}
            onChange={(e) => {
              this.onHandleChangeStore("middleName", e.target.value);
            }}
          />
        </div>

        <div className={styles.fieldContainer}>
          <div className={styles.fieldContainerDate}>
            <InputDate
              name={"birthday"}
              onHandleChangeStore={this.onHandleChangeStore.bind(this, "birthday")}
              valueStore={selectedDriver}
              maxDate={new Date().setFullYear(new Date().getFullYear() - 18)}
            />
            Дата рождения
          </div>
        </div>

        <div className={styles.fieldContainer}>
          <TextField
            id="outlined-basic"
            label="Телефон"
            variant="outlined"
            size="small"
            fullWidth={true}
            value={selectedDriver.phone}
            onChange={(e) => {
              this.onHandleChangeStore("phone", e.target.value);
            }}
          />
        </div>

        <div className={styles.fieldContainer}>
          <TextField
            id="outlined-basic"
            label="Дополнительная информация"
            variant="outlined"
            size="small"
            fullWidth={true}
            value={selectedDriver.description}
            onChange={(e) => {
              this.onHandleChangeStore("description", e.target.value);
            }}
          />
        </div>

        <div className={styles.titleCertivicate}>
          <p>Водительское удостоверение</p>
        </div>

        <div className={styles.fieldContainer}>
          <TextField
            id="outlined-basic"
            label="Серийный номер *"
            variant="outlined"
            size="small"
            fullWidth={true}
            value={selectedDriver.licenseNumber}
            onChange={(e) => {
              this.onHandleChangeStore("licenseNumber", e.target.value);
            }}
          />
        </div>

        <div className={styles.fieldContainer}>
          <TextField
            id="outlined-basic"
            label="Кем выдано *"
            variant="outlined"
            size="small"
            fullWidth={true}
            value={selectedDriver.licenseWhoGrant}
            onChange={(e) => {
              this.onHandleChangeStore("licenseWhoGrant", e.target.value);
            }}
          />
        </div>

        <div className={styles.fieldContainer}>
          <div className={styles.fieldContainerDate}>
            <InputDate
              name={"licenseDate"}
              onHandleChangeStore={this.onHandleChangeStore.bind(this, "licenseDate")}
              valueStore={selectedDriver}
              maxDate={new Date()}
            />
            Дата выдачи
          </div>
        </div>

        <div className={styles.fieldContainer}>
          <div className={styles.fieldContainerDate}>
            <InputDate
              name={"licensePeriod"}
              onHandleChangeStore={this.onHandleChangeStore.bind(this, "licensePeriod")}
              valueStore={selectedDriver}
            />
            Действительно до
          </div>
        </div>

        <div className={styles.title}>
          <p>Категории:</p>
        </div>
        <div className={styles.driverLicenseCategoryContainer}>
          {Object.keys(driverLicenseCategory).map((key) => {
            return (
              <div className={styles.fieldContainer}>
                <Checkbox
                  checked={selectedDriver.categories[key] !== undefined}
                  onChange={(e) => {
                    this.onHandleChangeCheckBox(key, e);
                  }}
                  style={{
                    padding: "0px",
                    transform: "scale(1)",
                  }}
                />
                <span>{driverLicenseCategory[key]}</span>
              </div>
            );
          })}
        </div>

        <div className={styles.buttonContainer}>
          {isChange ? (
            <ButtonPrimary
              disabled={this.buttonDisabled()}
              handleClick={this.onHandleClicklButton.bind(this)}
              title={selectedDriver.id === null ? "Создать" : "Обновить"}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

export default withDrivers(React.memo(ControlDriverTool));
